import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=2f16518e&scoped=true&"
import script from "./Beneficios.vue?vue&type=script&lang=js&"
export * from "./Beneficios.vue?vue&type=script&lang=js&"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=2f16518e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16518e",
  null
  
)

export default component.exports